import { render, staticRenderFns } from "./ModalCommon.vue?vue&type=template&id=065b8755&scoped=true"
import script from "./ModalCommon.vue?vue&type=script&lang=js"
export * from "./ModalCommon.vue?vue&type=script&lang=js"
import style0 from "./ModalCommon.vue?vue&type=style&index=0&id=065b8755&prod&scoped=true&lang=scss"
import style1 from "./ModalCommon.vue?vue&type=style&index=1&id=065b8755&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065b8755",
  null
  
)

export default component.exports